// Import style
import './style.scss';

/**
 * Listen to changes to the Title field and save it
 */
export default class RecipeTitle {
	/**
	 * Invokes method to listen to the Title field
	 * 
	 * @return {undefined}
	 */
	constructor() {
		document.getElementById( 'title' ).addEventListener( 'input', event => { 
			this.hasUnsavedData = true;
		} );

		document.getElementById( 'title' ).addEventListener( 'blur', event => {
			// Save only if the value changed
			if ( this.hasUnsavedData ) {
				UncannyAutomator._core.recipe.setRecipeTitle( event.target.value )
					.then( ( response ) => {
						this.hasUnsavedData = false;
					} );
			}
		} );
	}
}
